import { FC, ReactNode } from 'react'
import { Colors } from '../../../util/types'
import { icons } from '../../Icon/icons'
import PerButtonCircle from '../../ButtonCircle'

interface Props {
  icon: keyof typeof icons
  onClick: () => void
  color?: Colors
  tooltip?: string | ReactNode
}

export const PerInfoBoxActionButtonElement: FC<Props> = ({ icon, onClick, color, tooltip }) => {
  return <PerButtonCircle icon={icon} color={color} variant="pastel" size="large" tooltip={tooltip} onClick={onClick} />
}
